import router from './router'
import {logout} from "@/api/api"
import {getToken} from "@/utils/auth"
const whiteList = ['/login',"/regvip"] // 不重定向白名单
router.beforeEach((to, from, next) => {
  if(getToken()){
    if (whiteList.indexOf(to.path) !== -1) {
      next({ path: '/' })
    } 
    else{
      next()
    }
  }
  else{
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
    }
  }

  
  if (to.meta.title) {
    document.title = to.meta.title
  }
  else{
    document.title = '创建小程序 - 盈动科技'
  }

  next()

})



// WEBPACK FOOTER //
// ./src/permission.js